export enum TcPdfViewerActionsPosition {
  Top = 'top',
  Bottom = 'bottom',
  Both = 'both',
}
